import { Link } from "react-router";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./legal-footer.i18n";

export function LegalFooter() {
  const t = useT(T);
  return (
    <footer className="mt-8 text-center text-xs text-muted-foreground">
      <span>
        {t.by}{" "}
        <a
          href="https://quantfol.io"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          Quantfolio AS
        </a>
      </span>
      <span className="mx-1.5">·</span>
      <Link to="/tos" className="hover:underline">
        {t.terms}
      </Link>
      <span className="mx-1.5">·</span>
      <Link to="/privacy" className="hover:underline">
        {t.privacy}
      </Link>
    </footer>
  );
}
